import { createApi } from '@reduxjs/toolkit/query/react';
import axiosFetchBase from '../axiosFetchBase';
import { urls } from '../../utils/helpers/ApiClient';
import { isUndefined } from 'lodash';

export const filesApi = createApi({
  reducerPath: 'filesApi',
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getPresentationImages: builder.query({
      query: () => ({
        url: urls.presentationImages,
      }),
    }),
    uploadFile: builder.mutation({
      query: ({ url, file, directory, thumbnail }) => {
        const fd = new FormData(); // koli suboru musime poslat cez toto

        fd.append('file', file);

        if (!isUndefined(directory)) {
          fd.append('directory', directory);
        }

        if (!isUndefined(thumbnail)) {
          // FormData can't send bool variable, send string instead
          fd.append('thumbnail', thumbnail ? '1' : '0');
        }

        return {
          url: !isUndefined(url) ? url : urls.fileUpload,
          method: 'POST',
          data: fd,
        };
      },
    }),
  }),
});

export const { useUploadFileMutation, useGetPresentationImagesQuery } =
  filesApi;
